<template>
  <div class='home'>
    <ConvertList v-show="listView" @newConvert="onClickNewFromList" @editConvert="onClickEditFromList" :scroll="corY" ref="refreshConvert"/>
    <ConvertForm v-show="formView" :convert="convert" :convert2="convert2" @backClicked="onBackChild" @backSaveChild="onBackSaveChild" @backParentID="backParentID"/>
  </div>
</template>

<script>
// @ is an alias to /src
import ConvertList from '@/components/convert/ConvertList.vue'
import ConvertForm from '@/components/convert/ConvertForm.vue'
import { mapState } from 'vuex'
import axios from 'axios'
import { convertUrl, getHeader } from '@/config.js'

export default {
  name: 'Convert',
  components: {
    ConvertList,
    ConvertForm
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      warehouseList: state => state.warehouses.warehouseList
    })
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      convert: {
        id: null,
        convert_no: null,
        convert_date: null,
        product_no: null,
        qty: 0,
        total: 0,
        uom_id: null,
        uom_total: null,
        uoms: [],
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: null,
        warehouse_no: null,
        details: [{
          id: null,
          convert_no: null,
          convert_date: null,
          product_no: null,
          qty_stock: 0,
          uom_stock: null,
          qty: 0,
          total: 0,
          uom_id: null,
          qty_total: 0,
          uom_total: null,
          uoms: [],
          cost: 0,
          cost_total: 0,
          type: null,
          branch_no: null,
          company_no: null,
          warehouse_no: null
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: '0',
          credit: '0'
        }]
      },
      convert2: {
        id: null,
        convert_no: null,
        convert_date: null,
        product_no: null,
        qty: 0,
        total: 0,
        uom_id: null,
        uom_total: null,
        uoms: [],
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: null,
        warehouse_no: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.convert = value
      this.convert2 = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(this.authUser)
      var wh = this.warehouseList.find(d => d.company_no === this.authUser.company_no)
      this.convert = {
        id: null,
        convert_no: null,
        convert_date: new Date().toISOString(),
        product_no: null,
        qty: 0,
        qty_total: 0,
        uom_id: null,
        uom_total: null,
        uoms: [],
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: this.authUser.company_no,
        warehouse_no: wh.warehouse_no,
        details: [{
          id: null,
          convert_no: null,
          convert_date: null,
          product_no: null,
          qty_stock: 0,
          uom_stock: null,
          qty: 0,
          uom_id: null,
          qty_total: 0,
          uom_total: null,
          uoms: [],
          cost: 0,
          cost_total: 0,
          type: null,
          branch_no: null,
          company_no: this.authUser.company_no,
          warehouse_no: wh.warehouse_no
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: '0',
          credit: '0'
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.convert = {
        id: null,
        convert_no: null,
        convert_date: null,
        product_no: null,
        qty: 0,
        qty_total: 0,
        uom_id: null,
        uom_total: null,
        uoms: [],
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: null,
        warehouse_no: null,
        details: [{
          id: null,
          convert_no: null,
          convert_date: new Date().toISOString(),
          product_no: null,
          qty_stock: 0,
          uom_stock: null,
          qty: 0,
          uom_id: null,
          qty_total: 0,
          uom_total: null,
          uoms: [],
          cost: 0,
          cost_total: 0,
          type: null,
          branch_no: null,
          company_no: null,
          warehouse_no: null
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: '0',
          credit: '0'
        }]
      }
      this.convert2 = {
        id: null,
        convert_no: null,
        convert_date: null,
        product_no: null,
        qty: 0,
        total: 0,
        uom_id: null,
        uom_total: null,
        uoms: [],
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: null,
        warehouse_no: null
      }
    },
    async onBackSaveChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.convert = {
        id: null,
        convert_no: null,
        convert_date: null,
        product_no: null,
        qty: 0,
        qty_total: 0,
        uom_id: null,
        uom_total: null,
        uoms: [],
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: null,
        warehouse_no: null,
        details: [{
          id: null,
          convert_no: null,
          convert_date: null,
          product_no: null,
          qty_stock: 0,
          uom_stock: null,
          qty: 0,
          uom_id: null,
          qty_total: 0,
          uom_total: null,
          uoms: [],
          cost: 0,
          cost_total: 0,
          type: null,
          branch_no: null,
          company_no: null,
          warehouse_no: null
        }],
        journals: [{
          id: null,
          level: null,
          journal_code: null,
          journal_date: null,
          status: null,
          journal_description: null,
          account_code: null,
          account: null,
          remark: null,
          debit: '0',
          credit: '0'
        }]
      }
      this.$refs.refreshConvert.refreshConvert()
    },
    async backParentID (id) {
      await axios.get(convertUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    }
  },
  mounted () {
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getProductList')
    this.$store.dispatch('getRowTable')
  }
}
</script>
